import { Button } from 'primereact/button';
import styled from 'styled-components';

const IcButton = styled(Button).attrs((props) => ({
    className: [props.$outlined ? 'p-button-outlined' : ''].join(' '),
}))``;

export const DangerButton = styled(IcButton).attrs({
    className: 'p-button-danger',
})``;

export const PrimaryButton = styled(IcButton)``;

export const SuccessButton = styled(IcButton).attrs({
    className: 'p-button-success',
})``;

export const WarningButton = styled(IcButton).attrs({
    className: 'p-button-warning',
})``;
